import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Member } from '../../types';

interface MemberState {
  currentMember: Member | null;
  loading: boolean;
  error: string | null;
  updateSuccess: boolean;
}

const initialState: MemberState = {
  currentMember: null,
  loading: false,
  error: null,
  updateSuccess: false,
};

const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    fetchProfileStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProfileSuccess: (state, action: PayloadAction<Member>) => {
      state.loading = false;
      state.currentMember = action.payload;
      state.error = null;
    },
    fetchProfileFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateProfileStart: (state) => {
      state.loading = true;
      state.error = null;
      state.updateSuccess = false;
    },
    updateProfileSuccess: (state, action: PayloadAction<Member>) => {
      state.loading = false;
      state.currentMember = action.payload;
      state.error = null;
      state.updateSuccess = true;
    },
    updateProfileFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.updateSuccess = false;
    },
    clearMemberError: (state) => {
      state.error = null;
    },
    clearUpdateSuccess: (state) => {
      state.updateSuccess = false;
    },
    clearMemberProfile: (state) => {
      state.currentMember = null;
      state.loading = false;
      state.error = null;
      state.updateSuccess = false;
    },
  },
});

export const {
  fetchProfileStart,
  fetchProfileSuccess,
  fetchProfileFailure,
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailure,
  clearMemberError,
  clearUpdateSuccess,
  clearMemberProfile,
} = memberSlice.actions;

export default memberSlice.reducer;
